import {ClaimOrderList} from "./ClaimOrderList";
import {ClaimOrderEdit} from "./ClaimOrderEdit";
import {ClaimOrderCreate} from "./ClaimOrderCreate";

export default {
    list: ClaimOrderList,
    create: ClaimOrderCreate,
    edit: ClaimOrderEdit
};
